import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {  message,Checkbox,Button,Menu, Dropdown,Timeline ,Popover,Collapse,Select,DatePicker,Modal,Input  } from 'antd';
import {getData} from '../../../../services/index';
import {  QrcodeOutlined,PlusOutlined,DownOutlined,CheckOutlined,DeleteOutlined,RetweetOutlined,FieldTimeOutlined, EyeOutlined,SafetyCertificateOutlined,EditOutlined,MoreOutlined,PrinterOutlined,FileExcelOutlined,MessageOutlined,DownloadOutlined,MailOutlined,ImportOutlined,ExportOutlined } from '@ant-design/icons';

const CheckboxGroup = Checkbox.Group;

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;
function callback(key) {
  console.log(key);
}


class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			user_id:'',
			school_id:'',
			type: ''
		}
		this.handleSizeChange = this.handleSizeChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'] });
		
		}
		this.checkData();
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			
			var app = {school_id : school_id,user_id:user_id}
			getData('fees/account_fees_linking',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							type: result['data']
						});
					}else{
						this.setState({
							type: ''
						});
					}
				}
			});
			
	}
  }
	
	handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
			this.setState({ loading: true });
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var app = {
				type : this.state.type,
				school_id : storedArray['data'][0]['school_id'],
				user_id : storedArray['data'][0]['user_id'],
			}
			getData('fees/account_fees_linking_update',app).then((result) => {
				if(result.status==400){
					message.config({ top: 150});
					message.error('Please select fees setting Type',2);
					this.setState({ loading: false });
				}
				if(result.status==200){
					message.config({ top: 150});
					message.success('Account Fees Setting Updated',2);
					this.setState({ loading: false });
					window.location.href = '/settings/fees/account-fees-linking';
				}
		  });
	  }
	  else{
			message.error('Please Login',2);	
	  }

  }
  

	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
		
	};


	render() {
	
		return (
			<div class="mobile_view">
				<div id="main" class="bg-off">
					<div class="row">
						<div class="col col-md-12  ex-padd">
							<div id="breadcrumbs-wrapper" class="bg-off">
							   <div>
								  <div class="row no-margin">
									  <div class="col col-md-12  header-title mt-20 mh-40 iq-card">
										  <div class="col s12 m6 l6 pt-10 pb-15 ">
												<h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Account Fees Linking</span></h5>
											 </div>
											 	
											<div class="col s12 m6 l6 right-align-md pt-10">
												<ol class="breadcrumbs mb-0">
												   <li class="breadcrumb-item"><a href="/">Home</a></li>
												   <li class="breadcrumb-item"><a href="/settings/fees">Fees Setting</a></li>
												   <li class="breadcrumb-item active">Account Fees Linking</li>
												</ol>
											 </div>  
										 </div>
									  </div>
							   </div>
							</div>
						</div>
						<div class="col col-md-12  ex-padd enquiry bg-off">
							<div class="container">
								
								<div class="col col-md-12  mb-20 card-content iq-card">
									<section class="invoice-list-wrapper section food">
										<h2 class="sub-title">Link Fees and Account Module: </h2>
										
<div>
	<div class="radio"><label for="value1"><input checked={`${this.state.type==0?'checked':''}`} id="value1" type="radio" name="type" onChange={this.handleSizeChange} value="0"/> Fees and Account modules are not linked.</label></div>
    <div class="radio"><label for="value2"><input checked={`${this.state.type==1?'checked':''}`} id="value2" type="radio" name="type" onChange={this.handleSizeChange} value="1"/> Fees and account modules are linked.</label></div>
    <div class="col m12 s12 meal  mb-20 center">
		 <Button className="cancel-btn btn-lg large-btn"  onClick={this.context.router.history.goBack}>Back</Button>
		 <Button className="snd-btn btn-lg large-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
	</div>
</div>
										
										
										
									</section>
								</div>
								
								
							</div>
						</div>
           
					</div>
				</div>
			</div>
		) 
	} 
}
export default Index;
